import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { SubtitleNewCard, TextCircle } from '../../styles/typographyNewCard';

import { Container, CardInfo } from './styles';

interface ICard {
  description: string;
  path?: string;
  title: string;
  value?: string;
  name?: string;
}

const NewCard = ({ description, path, value, title, name }: ICard) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const width = window.innerWidth;

  const handleNextStep = () => {
    value &&
      name &&
      dispatch({ type: 'ADD_DEV_BUDGET', payload: { [name]: value } });
    if (path) {
      const currentParams = location.search;
      const hasAppParam = currentParams.includes('app');

      if (hasAppParam && !path.includes('?')) {
        history.push(`/ti/${path}?app`);
      } else {
        history.push(`/ti/${path}`);
      }
    }
  };
  return (
    <Container onClick={handleNextStep}>
      <CardInfo>
        <SubtitleNewCard onClick={handleNextStep}>{title}</SubtitleNewCard>
        <TextCircle onClick={handleNextStep}>{description}</TextCircle>
      </CardInfo>
    </Container>
  );
};

export default NewCard;
